"use strict";
/****************************************************
 * Audit Big Data System Query Engine
 * 带菜单的按钮组件
 * 2020-10
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var tinper_bee_1 = require("tinper-bee");
var utils_1 = require("../utils");
var Item = tinper_bee_1.Menu.Item;
/**
 * 带菜单的按钮组件
 */
var MenuButton = function (props) {
    var onClick = function (param) {
        props.items[param.key].onClick && props.items[param.key].onClick();
    };
    var onVisibleChange = function (visible) { };
    var menu = (
    // 2021年1月13日14:25:55 此处新增disabled 属性，默认为false，参数只接收Boolean类型  ---author 杜彦伟
    React.createElement(tinper_bee_1.Menu, { onClick: onClick }, props.items.map(function (da, idx) { return (React.createElement(Item, { key: idx, data: da, disabled: da.disabled ? da.disabled : false },
        da.icon ? React.createElement(tinper_bee_1.Icon, { type: da.icon }) : React.createElement(React.Fragment, null),
        (0, utils_1.getTranslate)(null, da.title || "没有标题"))); })));
    return (React.createElement("div", { style: { float: "left", fontSize: props.fontSize || 14 } },
        React.createElement(tinper_bee_1.Dropdown, { trigger: ["click"], overlay: menu, animation: "slide-up", onVisibleChange: onVisibleChange },
            React.createElement(tinper_bee_1.Button, { shape: "border", disabled: props.disabled },
                props.icon ? React.createElement(tinper_bee_1.Icon, { type: props.icon }) : React.createElement(React.Fragment, null),
                (0, utils_1.getTranslate)(null, props.title || "点击")))));
};
exports.default = MenuButton;
